import React from 'react'
import { useGlobalContext, accordionChange } from '../../state'

import TreeView from '@material-ui/lab/TreeView'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box
} from '@material-ui/core'

import { sectionComponents } from '../../utils/configQueries'
import { IconMap } from '../../utils/icons'
import { t } from '../../utils/languages'

import { SubTree } from './MenuIndicator/SubTree'
import { Submenu } from './Submenu'

import { useStyles } from './styles'

export const CustomAccordion = ({
  id,
  areaId,
  type,
  arrowIcon,
  icon,
  name,
  submenu,
  render,
  children
}) => {
  const classes = useStyles()
  const {
    state: { openAccordions },
    dispatch
  } = useGlobalContext()

  return (
    <Accordion expanded={openAccordions[type] === id}>
      <AccordionSummary
        key={areaId}
        id={areaId}
        expandIcon={
          (arrowIcon && IconMap.get(arrowIcon)) ||
          (children && IconMap.get('DetailsOutlined'))
        }
        onClick={() => dispatch(accordionChange({ id, type }))}
        className={`${type} ${children && 'firstChildren'}`}
      >
        <Box className={classes.boxIcon}>{icon && IconMap.get(icon)}</Box>
        <Typography variant={type === 'main' ? 'h5' : 'h6'}>
          {t(name)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <TreeView className={classes.root}>
          {children ? (
            children.map(
              (
                { children: grandChildren, area_id: grandId, name: grandName },
                index
              ) => (
                <SubTree key={index} id={grandId} name={grandName}>
                  {grandChildren}
                </SubTree>
              )
            )
          ) : render ? (
            sectionComponents.get(render)
          ) : (
            <Submenu items={submenu} />
          )}
        </TreeView>
      </AccordionDetails>
    </Accordion>
  )
}
